import { CommonModule } from '@angular/common';
import { Component, ViewEncapsulation, inject } from '@angular/core';
import { DialogBase } from '@app/components/dialog/dialog-base';
import { Store, select } from '@ngrx/store';
import * as GamesSelectors from '@app/store/features/games/games.selector';
import { BehaviorSubject, filter, map, shareReplay, Subject, tap } from 'rxjs';
import { FormBuilder, ReactiveFormsModule, Validators } from '@angular/forms';
import { InputComponent } from '@app/components/input/input.component';
import { ButtonComponent } from '@app/components/button/button.component';
import * as GamesActions from '@app/store/features/games/games.actions';
import { SpinnerComponent } from '@app/components/spinner/spinner.component';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-game-dialog-enter-password',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, InputComponent, ButtonComponent, AngularSvgIconModule, TranslateModule],
  templateUrl: './game-dialog-enter-password.component.html',
  styleUrl: './game-dialog-enter-password.component.scss',
  host: { class: 'dialog app-game-dialog-enter-password' },
  encapsulation: ViewEncapsulation.None
})
export class GameDialogEnterPasswordComponent extends DialogBase {
  private readonly _fb = inject(FormBuilder);
  password = this._fb.control('', { nonNullable: true })

  submit$ = new Subject<string>();
  loading$ = new BehaviorSubject<boolean>(false)
  showWrongPasswordError$ = new BehaviorSubject<boolean>(false)

  constructor() {
    super();
    this.password.valueChanges.pipe(takeUntilDestroyed(), tap(() => this.showWrongPasswordError$.next(false)))
      .subscribe()
  }

  onSubmit() {
    this.submit$.next(this.password.value)
    this.loading$.next(true)
  }

  onCancel() {
    this.close()
  }
}
